import React from "react";
import classes from "./About.module.scss";
import me from '../../images/me.webp'

const About = () => {
	return (
		<div className={classes.root}>
			<div className={classes.container}>
				<div className={classes.text}>
					<h2>O mně</h2>
					<h5>
						Jsem sedmnáctiletý programátor, fotograf a Linux master, který se drtivou většinu svých
						dovedností naučil svépomoci. Programovaní se věnuji sedmým rokem a již třetím rokem programuji
						na profesionální úrovni. Za svoji profesionální kariéru jsem pracoval například na velké
						enterprise aplikaci. Na základní škole jsem byl vybrán do soutěže v U6 pořádané Českou televizí.
						V prvním ročníku střední školy jsem se zapojil do okresní soutěže programování, ve které jsem
						skončil na třetím místě. V druhém ročníku střední školy jsem byl vybrán ředitelem školy do
						soutěže Hackathon. Zúčastnil jsem se také týdenního školení na virtualizační platformu VMWare a
						školení online marketingu. Ve svém volném čase také sportuji, hraji počítačové hry a vyučuji
						programování. K mým silným stránkám patří pozitivní přístup a chuť učit se něco nového
					</h5>
				</div>
				<img className={classes.image} src={me} alt=''/>
			</div>
		</div>
	)
}

export default About